//yuzu group
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";

//yuzu group custom module
import employeeManagement from "@/constants/navigation/BHMVVDXV3W7E/menu/employee-management";
import promotionManagement from "@/constants/navigation/BHMVVDXV3W7E/menu/promotion-management";
import customerManagement from "@/constants/navigation/BHMVVDXV3W7E/menu/customer-management";
import integration from "@/constants/navigation/BHMVVDXV3W7E/menu/integration";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVqAI5lt9wb4il": // Dev Yuzu Group BO UP
    case "PVxJXqS5OcDPR4": // Prod Yuzu Group BO UP
      switch (decodeToken()?.sub) {
        case "ID_wyLsEPyuTwBz":
        case "ID_OKWAoT9v1mKg":
          return [
            ...dataManagement,
            ...banner,
            ...article,
            ...privileges,
            ...fulfillment,
            ...inventory,
            ...document,
            ...tags,
            ...report,
            ...customerManagement,
            ...integration,
          ];
        case "ID_b7bqEqe6p6dD":
        case "ID_Q0VDsY8NUo5w":
          return [...employeeManagement, ...customerManagement, ...integration];
        // case "ID_wLSjQEUOexuo": //prod natnarapat.kh@chococrm.com
        //   return [...fulfillment, ...report];
      }
    case "PVSSrL9rUWezte": // Prod Yuzu Group BO EP
      switch (decodeToken()?.sub) {
        case "ID_wLSjQEUOexuo": //prod natnarapat.kh@chococrm.com
          return [...fulfillment, ...report];
      }
    default:
      return [
        ...dataManagement,
        ...banner,
        ...article,
        ...privileges,
        ...fulfillment,
        ...inventory,
        ...document,
        ...tags,
        ...report,
        ...employeeManagement,
        ...promotionManagement,
        ...customerManagement,
        ...integration,
      ];
  }
};

export default renderNavByPermission();
